// TODO: Find a home in the backend for this data
export var MIL_PAYGRADES = ['E-1', 'E-2', 'E-3', 'E-4', 'E-5', 'E-6', 'E-7', 'E-8', 'E-9', 'W-1', 'W-2', 'W-3', 'W-4', 'W-5', 'O-1E', 'O-2E', 'O-3E', 'O-1', 'O-2', 'O-3', 'O-4', 'O-5', 'O-6', 'O-7', 'O-8', 'O-9', 'O-10'];
export var MIL_ZIPCODES_TO_AREAS = {
  98001: 'WA309',
  98002: 'WA309',
  98003: 'WA309',
  98004: 'WA309',
  98005: 'WA309',
  98006: 'WA309',
  98007: 'WA309',
  98008: 'WA309',
  98009: 'WA309',
  98010: 'WA309',
  98011: 'WA309',
  98012: 'WA307',
  98013: 'WA309',
  98014: 'WA309',
  98015: 'WA309',
  98019: 'WA309',
  98020: 'WA307',
  98021: 'WA309',
  98022: 'WA309',
  98023: 'WA309',
  98024: 'WA309',
  98025: 'WA309',
  98026: 'WA307',
  98027: 'WA309',
  98028: 'WA309',
  98029: 'WA309',
  98030: 'WA309',
  98031: 'WA309',
  98032: 'WA309',
  98033: 'WA309',
  98034: 'WA309',
  98035: 'WA309',
  98036: 'WA307',
  98037: 'WA307',
  98038: 'WA309',
  98039: 'WA309',
  98040: 'WA309',
  98041: 'WA309',
  98042: 'WA309',
  98043: 'WA307',
  98045: 'WA309',
  98046: 'WA307',
  98047: 'WA309',
  98050: 'WA309',
  98051: 'WA309',
  98052: 'WA309',
  98053: 'WA309',
  98055: 'WA309',
  98056: 'WA309',
  98057: 'WA309',
  98058: 'WA309',
  98059: 'WA309',
  98061: 'WA306',
  98062: 'WA309',
  98063: 'WA309',
  98064: 'WA309',
  98065: 'WA309',
  98070: 'WA309',
  98071: 'WA309',
  98072: 'WA309',
  98073: 'WA309',
  98074: 'WA309',
  98075: 'WA309',
  98077: 'WA309',
  98082: 'WA307',
  98083: 'WA309',
  98087: 'WA307',
  98089: 'WA309',
  98092: 'WA309',
  98093: 'WA309',
  98101: 'WA309',
  98102: 'WA309',
  98103: 'WA309',
  98104: 'WA309',
  98105: 'WA309',
  98106: 'WA309',
  98107: 'WA309',
  98108: 'WA309',
  98109: 'WA309',
  98110: 'WA306',
  98111: 'WA309',
  98112: 'WA309',
  98113: 'WA309',
  98114: 'WA309',
  98115: 'WA309',
  98116: 'WA309',
  98117: 'WA309',
  98118: 'WA309',
  98119: 'WA309',
  98121: 'WA309',
  98122: 'WA309',
  98124: 'WA309',
  98125: 'WA309',
  98126: 'WA309',
  98127: 'WA309',
  98129: 'WA309',
  98131: 'WA309',
  98133: 'WA309',
  98134: 'WA309',
  98136: 'WA309',
  98138: 'WA309',
  98139: 'WA309',
  98141: 'WA309',
  98144: 'WA309',
  98145: 'WA309',
  98146: 'WA309',
  98148: 'WA309',
  98154: 'WA309',
  98155: 'WA309',
  98158: 'WA309',
  98160: 'WA309',
  98161: 'WA309',
  98164: 'WA309',
  98165: 'WA309',
  98166: 'WA309',
  98168: 'WA309',
  98170: 'WA309',
  98174: 'WA309',
  98175: 'WA309',
  98177: 'WA309',
  98178: 'WA309',
  98181: 'WA309',
  98185: 'WA309',
  98188: 'WA309',
  98190: 'WA309',
  98191: 'WA309',
  98194: 'WA309',
  98195: 'WA309',
  98198: 'WA309',
  98199: 'WA309',
  98201: 'WA307',
  98203: 'WA307',
  98204: 'WA307',
  98206: 'WA307',
  98207: 'WA307',
  98208: 'WA307',
  98213: 'WA307',
  98221: 'WA312',
  98222: 'WA312',
  98223: 'WA307',
  98224: 'WA309',
  98232: 'WA312',
  98233: 'WA312',
  98235: 'WA312',
  98236: 'WA312',
  98237: 'WA312',
  98238: 'WA312',
  98239: 'WA312',
  98241: 'WA307',
  98249: 'WA312',
  98251: 'WA307',
  98252: 'WA307',
  98253: 'WA312',
  98255: 'WA312',
  98256: 'WA307',
  98257: 'WA312',
  98258: 'WA307',
  98259: 'WA307',
  98260: 'WA312',
  98263: 'WA312',
  98267: 'WA312',
  98270: 'WA307',
  98271: 'WA307',
  98272: 'WA307',
  98273: 'WA312',
  98274: 'WA312',
  98275: 'WA307',
  98277: 'WA312',
  98278: 'WA312',
  98282: 'WA312',
  98283: 'WA312',
  98284: 'WA312',
  98287: 'WA307',
  98288: 'WA309',
  98290: 'WA307',
  98291: 'WA307',
  98292: 'WA307',
  98293: 'WA307',
  98294: 'WA307',
  98296: 'WA307',
  98303: 'WA311',
  98304: 'WA311',
  98305: 'WA308',
  98310: 'WA306',
  98311: 'WA306',
  98312: 'WA306',
  98314: 'WA306',
  98315: 'WA306',
  98321: 'WA311',
  98322: 'WA306',
  98323: 'WA311',
  98324: 'WA308',
  98325: 'WA308',
  98326: 'WA308',
  98327: 'WA311',
  98328: 'WA311',
  98329: 'WA311',
  98330: 'WA311',
  98331: 'WA308',
  98332: 'WA311',
  98333: 'WA311',
  98335: 'WA311',
  98337: 'WA306',
  98338: 'WA311',
  98339: 'WA308',
  98340: 'WA306',
  98342: 'WA306',
  98343: 'WA308',
  98344: 'WA311',
  98345: 'WA306',
  98346: 'WA306',
  98348: 'WA311',
  98349: 'WA311',
  98350: 'WA308',
  98351: 'WA311',
  98352: 'WA311',
  98353: 'WA306',
  98354: 'WA311',
  98357: 'WA308',
  98358: 'WA308',
  98359: 'WA306',
  98360: 'WA311',
  98362: 'WA308',
  98363: 'WA308',
  98364: 'WA306',
  98365: 'WA308',
  98366: 'WA306',
  98367: 'WA306',
  98368: 'WA308',
  98370: 'WA306',
  98371: 'WA311',
  98372: 'WA311',
  98373: 'WA311',
  98374: 'WA311',
  98375: 'WA311',
  98376: 'WA308',
  98378: 'WA306',
  98380: 'WA306',
  98381: 'WA308',
  98382: 'WA308',
  98383: 'WA306',
  98384: 'WA306',
  98385: 'WA311',
  98386: 'WA306',
  98387: 'WA311',
  98388: 'WA311',
  98390: 'WA311',
  98391: 'WA311',
  98392: 'WA306',
  98393: 'WA306',
  98394: 'WA311',
  98395: 'WA311',
  98396: 'WA311',
  98397: 'WA311',
  98398: 'WA311',
  98401: 'WA311',
  98402: 'WA311',
  98403: 'WA311',
  98404: 'WA311',
  98405: 'WA311',
  98406: 'WA311',
  98407: 'WA311',
  98408: 'WA311',
  98409: 'WA311',
  98411: 'WA311',
  98412: 'WA311',
  98413: 'WA311',
  98415: 'WA311',
  98416: 'WA311',
  98417: 'WA311',
  98418: 'WA311',
  98419: 'WA311',
  98421: 'WA311',
  98422: 'WA311',
  98424: 'WA311',
  98430: 'WA311',
  98431: 'WA311',
  98433: 'WA311',
  98438: 'WA311',
  98439: 'WA311',
  98443: 'WA311',
  98444: 'WA311',
  98445: 'WA311',
  98446: 'WA311',
  98447: 'WA311',
  98448: 'WA311',
  98464: 'WA311',
  98465: 'WA311',
  98466: 'WA311',
  98467: 'WA311',
  98471: 'WA311',
  98481: 'WA311',
  98490: 'WA311',
  98493: 'WA311',
  98496: 'WA311',
  98497: 'WA311',
  98498: 'WA311',
  98499: 'WA311',
  98501: 'WA311',
  98502: 'WA311',
  98503: 'WA311',
  98504: 'WA311',
  98505: 'WA311',
  98506: 'WA311',
  98507: 'WA311',
  98508: 'WA311',
  98509: 'WA311',
  98511: 'WA311',
  98512: 'WA311',
  98513: 'WA311',
  98516: 'WA311',
  98524: 'WA306',
  98528: 'WA306',
  98530: 'WA311',
  98540: 'WA311',
  98546: 'WA306',
  98548: 'WA306',
  98555: 'WA306',
  98556: 'WA311',
  98558: 'WA311',
  98560: 'WA306',
  98576: 'WA311',
  98579: 'WA311',
  98580: 'WA311',
  98584: 'WA306',
  98588: 'WA306',
  98589: 'WA311',
  98592: 'WA306',
  98597: 'WA311',
  98599: 'WA311',
  98901: 'WA313',
  98902: 'WA313',
  98903: 'WA313',
  98904: 'WA313',
  98907: 'WA313',
  98908: 'WA313',
  98909: 'WA313',
  98920: 'WA313',
  98921: 'WA313',
  98923: 'WA313',
  98930: 'WA313',
  98932: 'WA313',
  98933: 'WA313',
  98935: 'WA313',
  98936: 'WA313',
  98937: 'WA313',
  98938: 'WA313',
  98939: 'WA313',
  98942: 'WA313',
  98944: 'WA313',
  98947: 'WA313',
  98948: 'WA313',
  98951: 'WA313',
  98952: 'WA313',
  98953: 'WA313',
  99001: 'WA310',
  99003: 'WA310',
  99004: 'WA310',
  99005: 'WA310',
  99006: 'WA310',
  99009: 'WA310',
  99011: 'WA310',
  99012: 'WA310',
  99014: 'WA310',
  99016: 'WA310',
  99018: 'WA310',
  99019: 'WA310',
  99020: 'WA310',
  99021: 'WA310',
  99022: 'WA310',
  99023: 'WA310',
  99025: 'WA310',
  99026: 'WA310',
  99027: 'WA310',
  99030: 'WA310',
  99031: 'WA310',
  99036: 'WA310',
  99037: 'WA310',
  99039: 'WA310',
  99201: 'WA310',
  99202: 'WA310',
  99203: 'WA310',
  99204: 'WA310',
  99205: 'WA310',
  99206: 'WA310',
  99207: 'WA310',
  99208: 'WA310',
  99209: 'WA310',
  99210: 'WA310',
  99211: 'WA310',
  99212: 'WA310',
  99213: 'WA310',
  99214: 'WA310',
  99215: 'WA310',
  99216: 'WA310',
  99217: 'WA310',
  99218: 'WA310',
  99219: 'WA310',
  99220: 'WA310',
  99223: 'WA310',
  99224: 'WA310',
  99228: 'WA310',
  99251: 'WA310',
  99252: 'WA310',
  99256: 'WA310',
  99258: 'WA310',
  99260: 'WA310'
};
export var MIL_AREAS_TO_NAMES = {
  WA306: 'BREMERTON, WA',
  WA307: 'EVERETT, WA',
  WA308: 'PORT ANGELES, WA',
  WA309: 'SEATTLE, WA',
  WA310: 'SPOKANE, WA',
  WA311: 'TACOMA, WA',
  WA312: 'WHIDBEY ISLAND, WA',
  WA313: 'YAKIMA, WA'
};
export var MIL_BAH_LOOKUP = {
  WA306: {
    with_dependants: {
      'E-1': 2094.0,
      'E-2': 2094.0,
      'E-3': 2094.0,
      'E-4': 2094.0,
      'E-5': 2211.0,
      'E-6': 2502.0,
      'E-7': 2634.0,
      'E-8': 2775.0,
      'E-9': 2919.0,
      'W-1': 2523.0,
      'W-2': 2694.0,
      'W-3': 2868.0,
      'W-4': 2940.0,
      'W-5': 3030.0,
      'O-1E': 2658.0,
      'O-2E': 2841.0,
      'O-3E': 2952.0,
      'O-1': 2253.0,
      'O-2': 2499.0,
      'O-3': 2862.0,
      'O-4': 3054.0,
      'O-5': 3189.0,
      'O-6': 3213.0,
      'O-7': 3237.0,
      'O-8': 3237.0,
      'O-9': 3237.0,
      'O-10': 3237.0
    },
    without_dependants: {
      'E-1': 1710.0,
      'E-2': 1710.0,
      'E-3': 1710.0,
      'E-4': 1710.0,
      'E-5': 1875.0,
      'E-6': 1980.0,
      'E-7': 2094.0,
      'E-8': 2277.0,
      'E-9': 2355.0,
      'W-1': 2064.0,
      'W-2': 2274.0,
      'W-3': 2367.0,
      'W-4': 2532.0,
      'W-5': 2664.0,
      'O-1E': 2208.0,
      'O-2E': 2337.0,
      'O-3E': 2493.0,
      'O-1': 1971.0,
      'O-2': 2172.0,
      'O-3': 2394.0,
      'O-4': 2637.0,
      'O-5': 2718.0,
      'O-6': 2847.0,
      'O-7': 2895.0,
      'O-8': 2895.0,
      'O-9': 2895.0,
      'O-10': 2895.0
    }
  },
  WA307: {
    with_dependants: {
      'E-1': 2382.0,
      'E-2': 2382.0,
      'E-3': 2382.0,
      'E-4': 2382.0,
      'E-5': 2559.0,
      'E-6': 3099.0,
      'E-7': 3198.0,
      'E-8': 3300.0,
      'E-9': 3426.0,
      'W-1': 3120.0,
      'W-2': 3243.0,
      'W-3': 3369.0,
      'W-4': 3453.0,
      'W-5': 3555.0,
      'O-1E': 3213.0,
      'O-2E': 3348.0,
      'O-3E': 3465.0,
      'O-1': 2628.0,
      'O-2': 3093.0,
      'O-3': 3366.0,
      'O-4': 3585.0,
      'O-5': 3741.0,
      'O-6': 3771.0,
      'O-7': 3801.0,
      'O-8': 3801.0,
      'O-9': 3801.0,
      'O-10': 3801.0
    },
    without_dependants: {
      'E-1': 1827.0,
      'E-2': 1827.0,
      'E-3': 1827.0,
      'E-4': 1827.0,
      'E-5': 2067.0,
      'E-6': 2325.0,
      'E-7': 2400.0,
      'E-8': 2670.0,
      'E-9': 2829.0,
      'W-1': 2343.0,
      'W-2': 2667.0,
      'W-3': 2850.0,
      'W-4': 3120.0,
      'W-5': 3219.0,
      'O-1E': 2556.0,
      'O-2E': 2793.0,
      'O-3E': 3093.0,
      'O-1': 2199.0,
      'O-2': 2499.0,
      'O-3': 2901.0,
      'O-4': 3195.0,
      'O-5': 3255.0,
      'O-6': 3348.0,
      'O-7': 3405.0,
      'O-8': 3405.0,
      'O-9': 3405.0,
      'O-10': 3405.0
    }
  },
  WA308: {
    with_dependants: {
      'E-1': 1962.0,
      'E-2': 1962.0,
      'E-3': 1962.0,
      'E-4': 1962.0,
      'E-5': 2232.0,
      'E-6': 2712.0,
      'E-7': 2775.0,
      'E-8': 2841.0,
      'E-9': 2919.0,
      'W-1': 2733.0,
      'W-2': 2805.0,
      'W-3': 2886.0,
      'W-4': 2937.0,
      'W-5': 3003.0,
      'O-1E': 2784.0,
      'O-2E': 2871.0,
      'O-3E': 2943.0,
      'O-1': 2295.0,
      'O-2': 2709.0,
      'O-3': 2883.0,
      'O-4': 3021.0,
      'O-5': 3120.0,
      'O-6': 3144.0,
      'O-7': 3168.0,
      'O-8': 3168.0,
      'O-9': 3168.0,
      'O-10': 3168.0
    },
    without_dependants: {
      'E-1': 1473.0,
      'E-2': 1473.0,
      'E-3': 1473.0,
      'E-4': 1473.0,
      'E-5': 1674.0,
      'E-6': 2034.0,
      'E-7': 2082.0,
      'E-8': 2331.0,
      'E-9': 2472.0,
      'W-1': 2052.0,
      'W-2': 2328.0,
      'W-3': 2490.0,
      'W-4': 2727.0,
      'W-5': 2790.0,
      'O-1E': 2229.0,
      'O-2E': 2442.0,
      'O-3E': 2706.0,
      'O-1': 1722.0,
      'O-2': 2142.0,
      'O-3': 2538.0,
      'O-4': 2772.0,
      'O-5': 2808.0,
      'O-6': 2862.0,
      'O-7': 2910.0,
      'O-8': 2910.0,
      'O-9': 2910.0,
      'O-10': 2910.0
    }
  },
  WA309: {
    with_dependants: {
      'E-1': 2790.0,
      'E-2': 2790.0,
      'E-3': 2790.0,
      'E-4': 2790.0,
      'E-5': 2943.0,
      'E-6': 3942.0,
      'E-7': 4017.0,
      'E-8': 4098.0,
      'E-9': 4230.0,
      'W-1': 3963.0,
      'W-2': 4053.0,
      'W-3': 4152.0,
      'W-4': 4260.0,
      'W-5': 4395.0,
      'O-1E': 4029.0,
      'O-2E': 4134.0,
      'O-3E': 4278.0,
      'O-1': 3063.0,
      'O-2': 3927.0,
      'O-3': 4149.0,
      'O-4': 4440.0,
      'O-5': 4644.0,
      'O-6': 4683.0,
      'O-7': 4722.0,
      'O-8': 4722.0,
      'O-9': 4722.0,
      'O-10': 4722.0
    },
    without_dependants: {
      'E-1': 2130.0,
      'E-2': 2130.0,
      'E-3': 2130.0,
      'E-4': 2130.0,
      'E-5': 2457.0,
      'E-6': 2958.0,
      'E-7': 3012.0,
      'E-8': 3141.0,
      'E-9': 3447.0,
      'W-1': 2973.0,
      'W-2': 3138.0,
      'W-3': 3480.0,
      'W-4': 3957.0,
      'W-5': 4035.0,
      'O-1E': 3021.0,
      'O-2E': 3381.0,
      'O-3E': 3936.0,
      'O-1': 2631.0,
      'O-2': 3015.0,
      'O-3': 3579.0,
      'O-4': 4014.0,
      'O-5': 4059.0,
      'O-6': 4131.0,
      'O-7': 4203.0,
      'O-8': 4203.0,
      'O-9': 4203.0,
      'O-10': 4203.0
    }
  },
  WA310: {
    with_dependants: {
      'E-1': 1878.0,
      'E-2': 1878.0,
      'E-3': 1878.0,
      'E-4': 1878.0,
      'E-5': 2109.0,
      'E-6': 2610.0,
      'E-7': 2643.0,
      'E-8': 2673.0,
      'E-9': 2760.0,
      'W-1': 2631.0,
      'W-2': 2658.0,
      'W-3': 2700.0,
      'W-4': 2787.0,
      'W-5': 2898.0,
      'O-1E': 2646.0,
      'O-2E': 2688.0,
      'O-3E': 2802.0,
      'O-1': 2175.0,
      'O-2': 2607.0,
      'O-3': 2697.0,
      'O-4': 2934.0,
      'O-5': 3105.0,
      'O-6': 3129.0,
      'O-7': 3153.0,
      'O-8': 3153.0,
      'O-9': 3153.0,
      'O-10': 3153.0
    },
    without_dependants: {
      'E-1': 1497.0,
      'E-2': 1497.0,
      'E-3': 1497.0,
      'E-4': 1497.0,
      'E-5': 1584.0,
      'E-6': 1959.0,
      'E-7': 1983.0,
      'E-8': 2211.0,
      'E-9': 2361.0,
      'W-1': 1977.0,
      'W-2': 2208.0,
      'W-3': 2379.0,
      'W-4': 2616.0,
      'W-5': 2649.0,
      'O-1E': 2106.0,
      'O-2E': 2325.0,
      'O-3E': 2604.0,
      'O-1': 1641.0,
      'O-2': 2031.0,
      'O-3': 2427.0,
      'O-4': 2634.0,
      'O-5': 2652.0,
      'O-6': 2673.0,
      'O-7': 2718.0,
      'O-8': 2718.0,
      'O-9': 2718.0,
      'O-10': 2718.0
    }
  },
  WA311: {
    with_dependants: {
      'E-1': 2235.0,
      'E-2': 2235.0,
      'E-3': 2235.0,
      'E-4': 2235.0,
      'E-5': 2430.0,
      'E-6': 2724.0,
      'E-7': 2805.0,
      'E-8': 2892.0,
      'E-9': 3003.0,
      'W-1': 2742.0,
      'W-2': 2841.0,
      'W-3': 2949.0,
      'W-4': 3027.0,
      'W-5': 3123.0,
      'O-1E': 2817.0,
      'O-2E': 2931.0,
      'O-3E': 3039.0,
      'O-1': 2472.0,
      'O-2': 2721.0,
      'O-3': 2946.0,
      'O-4': 3150.0,
      'O-5': 3297.0,
      'O-6': 3321.0,
      'O-7': 3348.0,
      'O-8': 3348.0,
      'O-9': 3348.0,
      'O-10': 3348.0
    },
    without_dependants: {
      'E-1': 1683.0,
      'E-2': 1683.0,
      'E-3': 1683.0,
      'E-4': 1683.0,
      'E-5': 1908.0,
      'E-6': 2055.0,
      'E-7': 2241.0,
      'E-8': 2493.0,
      'E-9': 2574.0,
      'W-1': 2175.0,
      'W-2': 2490.0,
      'W-3': 2586.0,
      'W-4': 2739.0,
      'W-5': 2823.0,
      'O-1E': 2427.0,
      'O-2E': 2556.0,
      'O-3E': 2715.0,
      'O-1': 2034.0,
      'O-2': 2364.0,
      'O-3': 2613.0,
      'O-4': 2802.0,
      'O-5': 2850.0,
      'O-6': 2928.0,
      'O-7': 2976.0,
      'O-8': 2976.0,
      'O-9': 2976.0,
      'O-10': 2976.0
    }
  },
  WA312: {
    with_dependants: {
      'E-1': 1848.0,
      'E-2': 1848.0,
      'E-3': 1848.0,
      'E-4': 1848.0,
      'E-5': 1896.0,
      'E-6': 2505.0,
      'E-7': 2637.0,
      'E-8': 2778.0,
      'E-9': 2904.0,
      'W-1': 2529.0,
      'W-2': 2700.0,
      'W-3': 2871.0,
      'W-4': 2919.0,
      'W-5': 2979.0,
      'O-1E': 2661.0,
      'O-2E': 2844.0,
      'O-3E': 2925.0,
      'O-1': 1974.0,
      'O-2': 2499.0,
      'O-3': 2865.0,
      'O-4': 2994.0,
      'O-5': 3081.0,
      'O-6': 3105.0,
      'O-7': 3129.0,
      'O-8': 3129.0,
      'O-9': 3129.0,
      'O-10': 3129.0
    },
    without_dependants: {
      'E-1': 1428.0,
      'E-2': 1428.0,
      'E-3': 1428.0,
      'E-4': 1428.0,
      'E-5': 1662.0,
      'E-6': 1878.0,
      'E-7': 1977.0,
      'E-8': 2085.0,
      'E-9': 2202.0,
      'W-1': 1899.0,
      'W-2': 2025.0,
      'W-3': 2226.0,
      'W-4': 2538.0,
      'W-5': 2670.0,
      'O-1E': 1995.0,
      'O-2E': 2163.0,
      'O-3E': 2499.0,
      'O-1': 1794.0,
      'O-2': 1980.0,
      'O-3': 2283.0,
      'O-4': 2640.0,
      'O-5': 2721.0,
      'O-6': 2850.0,
      'O-7': 2898.0,
      'O-8': 2898.0,
      'O-9': 2898.0,
      'O-10': 2898.0
    }
  },
  WA313: {
    with_dependants: {
      'E-1': 1464.0,
      'E-2': 1464.0,
      'E-3': 1464.0,
      'E-4': 1464.0,
      'E-5': 1629.0,
      'E-6': 2148.0,
      'E-7': 2193.0,
      'E-8': 2238.0,
      'E-9': 2376.0,
      'W-1': 2169.0,
      'W-2': 2214.0,
      'W-3': 2271.0,
      'W-4': 2421.0,
      'W-5': 2604.0,
      'O-1E': 2196.0,
      'O-2E': 2259.0,
      'O-3E': 2445.0,
      'O-1': 1698.0,
      'O-2': 2142.0,
      'O-3': 2268.0,
      'O-4': 2667.0,
      'O-5': 2952.0,
      'O-6': 2973.0,
      'O-7': 2997.0,
      'O-8': 2997.0,
      'O-9': 2997.0,
      'O-10': 2997.0
    },
    without_dependants: {
      'E-1': 1098.0,
      'E-2': 1098.0,
      'E-3': 1098.0,
      'E-4': 1098.0,
      'E-5': 1221.0,
      'E-6': 1611.0,
      'E-7': 1644.0,
      'E-8': 1737.0,
      'E-9': 1890.0,
      'W-1': 1629.0,
      'W-2': 1734.0,
      'W-3': 1908.0,
      'W-4': 2157.0,
      'W-5': 2202.0,
      'O-1E': 1650.0,
      'O-2E': 1854.0,
      'O-3E': 2142.0,
      'O-1': 1296.0,
      'O-2': 1647.0,
      'O-3': 1959.0,
      'O-4': 2184.0,
      'O-5': 2214.0,
      'O-6': 2247.0,
      'O-7': 2283.0,
      'O-8': 2283.0,
      'O-9': 2283.0,
      'O-10': 2283.0
    }
  }
};
export var MIL_LENGTH_OF_SERVICE_OPTIONS = ['<4mos', '2 or less', 'Over 2', 'Over 3', 'Over 4', 'Over 6', 'Over 8', 'Over 10', 'Over 12', 'Over 14', 'Over 16', 'Over 18', 'Over 20', 'Over 22', 'Over 24', 'Over 26', 'Over 28', 'Over 30', 'Over 32', 'Over 34', 'Over 36', 'Over 38', 'Over 40'];
export var MIL_ACTIVE_BASE_PAY_LOOKUP = {
  'O-10': {
    '2 or less': null,
    'Over 2': null,
    'Over 3': null,
    'Over 4': null,
    'Over 6': null,
    'Over 8': null,
    'Over 10': null,
    'Over 12': null,
    'Over 14': null,
    'Over 16': null,
    'Over 18': null,
    'Over 20': 18491.7,
    'Over 22': 18491.7,
    'Over 24': 18491.7,
    'Over 26': 18491.7,
    'Over 28': 18491.7,
    'Over 30': 18491.7,
    'Over 32': 18491.7,
    'Over 34': 18491.7,
    'Over 36': 18491.7,
    'Over 38': 18491.7,
    'Over 40': 18491.7
  },
  'O-9': {
    '2 or less': null,
    'Over 2': null,
    'Over 3': null,
    'Over 4': null,
    'Over 6': null,
    'Over 8': null,
    'Over 10': null,
    'Over 12': null,
    'Over 14': null,
    'Over 16': null,
    'Over 18': null,
    'Over 20': 18096.0,
    'Over 22': 18357.3,
    'Over 24': 18491.7,
    'Over 26': 18491.7,
    'Over 28': 18491.7,
    'Over 30': 18491.7,
    'Over 32': 18491.7,
    'Over 34': 18491.7,
    'Over 36': 18491.7,
    'Over 38': 18491.7,
    'Over 40': 18491.7
  },
  'O-8': {
    '2 or less': 12803.7,
    'Over 2': 13223.7,
    'Over 3': 13501.8,
    'Over 4': 13579.2,
    'Over 6': 13926.9,
    'Over 8': 14506.5,
    'Over 10': 14641.8,
    'Over 12': 15192.6,
    'Over 14': 15351.3,
    'Over 16': 15825.9,
    'Over 18': 16512.9,
    'Over 20': 17145.6,
    'Over 22': 17568.6,
    'Over 24': 17568.6,
    'Over 26': 17568.6,
    'Over 28': 17568.6,
    'Over 30': 18008.4,
    'Over 32': 18008.4,
    'Over 34': 18458.1,
    'Over 36': 18458.1,
    'Over 38': 18458.1,
    'Over 40': 18458.1
  },
  'O-7': {
    '2 or less': 10638.9,
    'Over 2': 11133.0,
    'Over 3': 11361.9,
    'Over 4': 11544.0,
    'Over 6': 11872.8,
    'Over 8': 12198.3,
    'Over 10': 12574.2,
    'Over 12': 12948.9,
    'Over 14': 13325.4,
    'Over 16': 14506.5,
    'Over 18': 15504.3,
    'Over 20': 15504.3,
    'Over 22': 15504.3,
    'Over 24': 15504.3,
    'Over 26': 15584.1,
    'Over 28': 15584.1,
    'Over 30': 15895.8,
    'Over 32': 15895.8,
    'Over 34': 15895.8,
    'Over 36': 15895.8,
    'Over 38': 15895.8,
    'Over 40': 15895.8
  },
  'O-6': {
    '2 or less': 8067.9,
    'Over 2': 8863.2,
    'Over 3': 9444.9,
    'Over 4': 9444.9,
    'Over 6': 9481.2,
    'Over 8': 9887.4,
    'Over 10': 9941.4,
    'Over 12': 9941.4,
    'Over 14': 10506.3,
    'Over 16': 11505.0,
    'Over 18': 12091.2,
    'Over 20': 12677.1,
    'Over 22': 13010.7,
    'Over 24': 13348.5,
    'Over 26': 14002.8,
    'Over 28': 14002.8,
    'Over 30': 14282.4,
    'Over 32': 14282.4,
    'Over 34': 14282.4,
    'Over 36': 14282.4,
    'Over 38': 14282.4,
    'Over 40': 14282.4
  },
  'O-5': {
    '2 or less': 6725.7,
    'Over 2': 7576.5,
    'Over 3': 8100.9,
    'Over 4': 8199.6,
    'Over 6': 8527.2,
    'Over 8': 8722.5,
    'Over 10': 9153.0,
    'Over 12': 9469.8,
    'Over 14': 9878.1,
    'Over 16': 10501.8,
    'Over 18': 10799.1,
    'Over 20': 11093.1,
    'Over 22': 11426.7,
    'Over 24': 11426.7,
    'Over 26': 11426.7,
    'Over 28': 11426.7,
    'Over 30': 11426.7,
    'Over 32': 11426.7,
    'Over 34': 11426.7,
    'Over 36': 11426.7,
    'Over 38': 11426.7,
    'Over 40': 11426.7
  },
  'O-4': {
    '2 or less': 5803.2,
    'Over 2': 6717.3,
    'Over 3': 7166.4,
    'Over 4': 7265.4,
    'Over 6': 7681.5,
    'Over 8': 8127.9,
    'Over 10': 8684.1,
    'Over 12': 9116.1,
    'Over 14': 9416.7,
    'Over 16': 9589.5,
    'Over 18': 9689.1,
    'Over 20': 9689.1,
    'Over 22': 9689.1,
    'Over 24': 9689.1,
    'Over 26': 9689.1,
    'Over 28': 9689.1,
    'Over 30': 9689.1,
    'Over 32': 9689.1,
    'Over 34': 9689.1,
    'Over 36': 9689.1,
    'Over 38': 9689.1,
    'Over 40': 9689.1
  },
  'O-3': {
    '2 or less': 5102.1,
    'Over 2': 5783.7,
    'Over 3': 6241.8,
    'Over 4': 6806.1,
    'Over 6': 7132.8,
    'Over 8': 7490.7,
    'Over 10': 7721.7,
    'Over 12': 8102.1,
    'Over 14': 8301.0,
    'Over 16': 8301.0,
    'Over 18': 8301.0,
    'Over 20': 8301.0,
    'Over 22': 8301.0,
    'Over 24': 8301.0,
    'Over 26': 8301.0,
    'Over 28': 8301.0,
    'Over 30': 8301.0,
    'Over 32': 8301.0,
    'Over 34': 8301.0,
    'Over 36': 8301.0,
    'Over 38': 8301.0,
    'Over 40': 8301.0
  },
  'O-2': {
    '2 or less': 4408.5,
    'Over 2': 5020.8,
    'Over 3': 5782.8,
    'Over 4': 5978.1,
    'Over 6': 6100.8,
    'Over 8': 6100.8,
    'Over 10': 6100.8,
    'Over 12': 6100.8,
    'Over 14': 6100.8,
    'Over 16': 6100.8,
    'Over 18': 6100.8,
    'Over 20': 6100.8,
    'Over 22': 6100.8,
    'Over 24': 6100.8,
    'Over 26': 6100.8,
    'Over 28': 6100.8,
    'Over 30': 6100.8,
    'Over 32': 6100.8,
    'Over 34': 6100.8,
    'Over 36': 6100.8,
    'Over 38': 6100.8,
    'Over 40': 6100.8
  },
  'O-1': {
    '2 or less': 3826.2,
    'Over 2': 3982.8,
    'Over 3': 4814.7,
    'Over 4': 4814.7,
    'Over 6': 4814.7,
    'Over 8': 4814.7,
    'Over 10': 4814.7,
    'Over 12': 4814.7,
    'Over 14': 4814.7,
    'Over 16': 4814.7,
    'Over 18': 4814.7,
    'Over 20': 4814.7,
    'Over 22': 4814.7,
    'Over 24': 4814.7,
    'Over 26': 4814.7,
    'Over 28': 4814.7,
    'Over 30': 4814.7,
    'Over 32': 4814.7,
    'Over 34': 4814.7,
    'Over 36': 4814.7,
    'Over 38': 4814.7,
    'Over 40': 4814.7
  },
  'O-3E': {
    '2 or less': null,
    'Over 2': null,
    'Over 3': null,
    'Over 4': 6806.1,
    'Over 6': 7132.8,
    'Over 8': 7490.7,
    'Over 10': 7721.7,
    'Over 12': 8102.1,
    'Over 14': 8423.4,
    'Over 16': 8607.9,
    'Over 18': 8859.0,
    'Over 20': 8859.0,
    'Over 22': 8859.0,
    'Over 24': 8859.0,
    'Over 26': 8859.0,
    'Over 28': 8859.0,
    'Over 30': 8859.0,
    'Over 32': 8859.0,
    'Over 34': 8859.0,
    'Over 36': 8859.0,
    'Over 38': 8859.0,
    'Over 40': 8859.0
  },
  'O-2E': {
    '2 or less': null,
    'Over 2': null,
    'Over 3': null,
    'Over 4': 5978.1,
    'Over 6': 6100.8,
    'Over 8': 6294.9,
    'Over 10': 6622.8,
    'Over 12': 6876.6,
    'Over 14': 7065.0,
    'Over 16': 7065.0,
    'Over 18': 7065.0,
    'Over 20': 7065.0,
    'Over 22': 7065.0,
    'Over 24': 7065.0,
    'Over 26': 7065.0,
    'Over 28': 7065.0,
    'Over 30': 7065.0,
    'Over 32': 7065.0,
    'Over 34': 7065.0,
    'Over 36': 7065.0,
    'Over 38': 7065.0,
    'Over 40': 7065.0
  },
  'O-1E': {
    '2 or less': null,
    'Over 2': null,
    'Over 3': null,
    'Over 4': 4814.7,
    'Over 6': 5141.1,
    'Over 8': 5331.3,
    'Over 10': 5525.7,
    'Over 12': 5716.5,
    'Over 14': 5978.1,
    'Over 16': 5978.1,
    'Over 18': 5978.1,
    'Over 20': 5978.1,
    'Over 22': 5978.1,
    'Over 24': 5978.1,
    'Over 26': 5978.1,
    'Over 28': 5978.1,
    'Over 30': 5978.1,
    'Over 32': 5978.1,
    'Over 34': 5978.1,
    'Over 36': 5978.1,
    'Over 38': 5978.1,
    'Over 40': 5978.1
  },
  'W-5': {
    '2 or less': null,
    'Over 2': null,
    'Over 3': null,
    'Over 4': null,
    'Over 6': null,
    'Over 8': null,
    'Over 10': null,
    'Over 12': null,
    'Over 14': null,
    'Over 16': null,
    'Over 18': null,
    'Over 20': 9375.6,
    'Over 22': 9851.1,
    'Over 24': 10205.7,
    'Over 26': 10597.2,
    'Over 28': 10597.2,
    'Over 30': 11128.2,
    'Over 32': 11128.2,
    'Over 34': 11683.5,
    'Over 36': 11683.5,
    'Over 38': 12269.1,
    'Over 40': 12269.1
  },
  'W-4': {
    '2 or less': 5273.1,
    'Over 2': 5671.5,
    'Over 3': 5834.4,
    'Over 4': 5994.6,
    'Over 6': 6270.6,
    'Over 8': 6543.6,
    'Over 10': 6820.2,
    'Over 12': 7235.4,
    'Over 14': 7599.9,
    'Over 16': 7946.7,
    'Over 18': 8231.1,
    'Over 20': 8508.3,
    'Over 22': 8914.5,
    'Over 24': 9248.7,
    'Over 26': 9629.7,
    'Over 28': 9629.7,
    'Over 30': 9821.7,
    'Over 32': 9821.7,
    'Over 34': 9821.7,
    'Over 36': 9821.7,
    'Over 38': 9821.7,
    'Over 40': 9821.7
  },
  'W-3': {
    '2 or less': 4815.6,
    'Over 2': 5015.7,
    'Over 3': 5222.1,
    'Over 4': 5289.0,
    'Over 6': 5504.4,
    'Over 8': 5928.9,
    'Over 10': 6370.8,
    'Over 12': 6579.0,
    'Over 14': 6819.9,
    'Over 16': 7067.4,
    'Over 18': 7513.8,
    'Over 20': 7814.7,
    'Over 22': 7994.7,
    'Over 24': 8186.1,
    'Over 26': 8447.1,
    'Over 28': 8447.1,
    'Over 30': 8447.1,
    'Over 32': 8447.1,
    'Over 34': 8447.1,
    'Over 36': 8447.1,
    'Over 38': 8447.1,
    'Over 40': 8447.1
  },
  'W-2': {
    '2 or less': 4260.9,
    'Over 2': 4663.8,
    'Over 3': 4787.7,
    'Over 4': 4873.2,
    'Over 6': 5149.2,
    'Over 8': 5578.5,
    'Over 10': 5791.8,
    'Over 12': 6001.2,
    'Over 14': 6257.4,
    'Over 16': 6457.8,
    'Over 18': 6639.0,
    'Over 20': 6856.2,
    'Over 22': 6998.7,
    'Over 24': 7111.8,
    'Over 26': 7111.8,
    'Over 28': 7111.8,
    'Over 30': 7111.8,
    'Over 32': 7111.8,
    'Over 34': 7111.8,
    'Over 36': 7111.8,
    'Over 38': 7111.8,
    'Over 40': 7111.8
  },
  'W-1': {
    '2 or less': 3739.8,
    'Over 2': 4143.0,
    'Over 3': 4250.7,
    'Over 4': 4479.6,
    'Over 6': 4749.9,
    'Over 8': 5148.3,
    'Over 10': 5334.3,
    'Over 12': 5595.3,
    'Over 14': 5850.9,
    'Over 16': 6052.2,
    'Over 18': 6237.6,
    'Over 20': 6462.9,
    'Over 22': 6462.9,
    'Over 24': 6462.9,
    'Over 26': 6462.9,
    'Over 28': 6462.9,
    'Over 30': 6462.9,
    'Over 32': 6462.9,
    'Over 34': 6462.9,
    'Over 36': 6462.9,
    'Over 38': 6462.9,
    'Over 40': 6462.9
  },
  'E-9': {
    '2 or less': null,
    'Over 2': null,
    'Over 3': null,
    'Over 4': null,
    'Over 6': null,
    'Over 8': null,
    'Over 10': 6370.5,
    'Over 12': 6514.8,
    'Over 14': 6696.6,
    'Over 16': 6910.5,
    'Over 18': 7127.1,
    'Over 20': 7472.1,
    'Over 22': 7765.2,
    'Over 24': 8072.7,
    'Over 26': 8544.0,
    'Over 28': 8544.0,
    'Over 30': 8970.3,
    'Over 32': 8970.3,
    'Over 34': 9419.4,
    'Over 36': 9419.4,
    'Over 38': 9891.3,
    'Over 40': 9891.3
  },
  'E-8': {
    '2 or less': null,
    'Over 2': null,
    'Over 3': null,
    'Over 4': null,
    'Over 6': null,
    'Over 8': 5214.9,
    'Over 10': 5445.61,
    'Over 12': 5588.4,
    'Over 14': 5759.4,
    'Over 16': 5944.5,
    'Over 18': 6279.3,
    'Over 20': 6449.1,
    'Over 22': 6737.4,
    'Over 24': 6897.3,
    'Over 26': 7291.2,
    'Over 28': 7291.2,
    'Over 30': 7437.3,
    'Over 32': 7437.3,
    'Over 34': 7437.3,
    'Over 36': 7437.3,
    'Over 38': 7437.3,
    'Over 40': 7437.3
  },
  'E-7': {
    '2 or less': 3624.9,
    'Over 2': 3956.4,
    'Over 3': 4108.2,
    'Over 4': 4308.3,
    'Over 6': 4465.5,
    'Over 8': 4734.6,
    'Over 10': 4886.4,
    'Over 12': 5155.2,
    'Over 14': 5379.3,
    'Over 16': 5532.3,
    'Over 18': 5694.9,
    'Over 20': 5757.9,
    'Over 22': 5969.7,
    'Over 24': 6083.1,
    'Over 26': 6515.7,
    'Over 28': 6515.7,
    'Over 30': 6515.7,
    'Over 32': 6515.7,
    'Over 34': 6515.7,
    'Over 36': 6515.7,
    'Over 38': 6515.7,
    'Over 40': 6515.7
  },
  'E-6': {
    '2 or less': 3135.6,
    'Over 2': 3450.6,
    'Over 3': 3603.0,
    'Over 4': 3750.9,
    'Over 6': 3904.8,
    'Over 8': 4252.5,
    'Over 10': 4387.8,
    'Over 12': 4649.7,
    'Over 14': 4729.8,
    'Over 16': 4788.0,
    'Over 18': 4856.4,
    'Over 20': 4856.4,
    'Over 22': 4856.4,
    'Over 24': 4856.4,
    'Over 26': 4856.4,
    'Over 28': 4856.4,
    'Over 30': 4856.4,
    'Over 32': 4856.4,
    'Over 34': 4856.4,
    'Over 36': 4856.4,
    'Over 38': 4856.4,
    'Over 40': 4856.4
  },
  'E-5': {
    '2 or less': 2872.2,
    'Over 2': 3065.7,
    'Over 3': 3214.2,
    'Over 4': 3365.7,
    'Over 6': 3601.8,
    'Over 8': 3848.7,
    'Over 10': 4052.1,
    'Over 12': 4076.4,
    'Over 14': 4076.4,
    'Over 16': 4076.4,
    'Over 18': 4076.4,
    'Over 20': 4076.4,
    'Over 22': 4076.4,
    'Over 24': 4076.4,
    'Over 26': 4076.4,
    'Over 28': 4076.4,
    'Over 30': 4076.4,
    'Over 32': 4076.4,
    'Over 34': 4076.4,
    'Over 36': 4076.4,
    'Over 38': 4076.4,
    'Over 40': 4076.4
  },
  'E-4': {
    '2 or less': 2633.7,
    'Over 2': 2768.4,
    'Over 3': 2918.4,
    'Over 4': 3066.3,
    'Over 6': 3197.4,
    'Over 8': 3197.4,
    'Over 10': 3197.4,
    'Over 12': 3197.4,
    'Over 14': 3197.4,
    'Over 16': 3197.4,
    'Over 18': 3197.4,
    'Over 20': 3197.4,
    'Over 22': 3197.4,
    'Over 24': 3197.4,
    'Over 26': 3197.4,
    'Over 28': 3197.4,
    'Over 30': 3197.4,
    'Over 32': 3197.4,
    'Over 34': 3197.4,
    'Over 36': 3197.4,
    'Over 38': 3197.4,
    'Over 40': 3197.4
  },
  'E-3': {
    '2 or less': 2377.5,
    'Over 2': 2526.9,
    'Over 3': 2680.2,
    'Over 4': 2680.2,
    'Over 6': 2680.2,
    'Over 8': 2680.2,
    'Over 10': 2680.2,
    'Over 12': 2680.2,
    'Over 14': 2680.2,
    'Over 16': 2680.2,
    'Over 18': 2680.2,
    'Over 20': 2680.2,
    'Over 22': 2680.2,
    'Over 24': 2680.2,
    'Over 26': 2680.2,
    'Over 28': 2680.2,
    'Over 30': 2680.2,
    'Over 32': 2680.2,
    'Over 34': 2680.2,
    'Over 36': 2680.2,
    'Over 38': 2680.2,
    'Over 40': 2680.2
  },
  'E-2': {
    '2 or less': 2261.1,
    'Over 2': 2261.1,
    'Over 3': 2261.1,
    'Over 4': 2261.1,
    'Over 6': 2261.1,
    'Over 8': 2261.1,
    'Over 10': 2261.1,
    'Over 12': 2261.1,
    'Over 14': 2261.1,
    'Over 16': 2261.1,
    'Over 18': 2261.1,
    'Over 20': 2261.1,
    'Over 22': 2261.1,
    'Over 24': 2261.1,
    'Over 26': 2261.1,
    'Over 28': 2261.1,
    'Over 30': 2261.1,
    'Over 32': 2261.1,
    'Over 34': 2261.1,
    'Over 36': 2261.1,
    'Over 38': 2261.1,
    'Over 40': 2261.1
  },
  'E-1': {
    '<4mos': 1865.1,
    '2 or less': 2017.2,
    'Over 2': 2017.2,
    'Over 3': 2017.2,
    'Over 4': 2017.2,
    'Over 6': 2017.2,
    'Over 8': 2017.2,
    'Over 10': 2017.2,
    'Over 12': 2017.2,
    'Over 14': 2017.2,
    'Over 16': 2017.2,
    'Over 18': 2017.2,
    'Over 20': 2017.2,
    'Over 22': 2017.2,
    'Over 24': 2017.2,
    'Over 26': 2017.2,
    'Over 28': 2017.2,
    'Over 30': 2017.2,
    'Over 32': 2017.2,
    'Over 34': 2017.2,
    'Over 36': 2017.2,
    'Over 38': 2017.2,
    'Over 40': 2017.2
  }
};